import { render, staticRenderFns } from "./SuppliesDlivyStatus.vue?vue&type=template&id=ff534d8c&scoped=true&"
import script from "./SuppliesDlivyStatus.vue?vue&type=script&lang=js&"
export * from "./SuppliesDlivyStatus.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesDlivyStatus.vue?vue&type=style&index=0&id=ff534d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff534d8c",
  null
  
)

export default component.exports